import customAxios from "../index";

export type AdminDashboardPartnerType = "provider" | "planner";
export type AdminDashboardExportSection =
  | "adminOrderRevenueReport"
  | "adminLeadConversionRateReport"
  | "adminEarningsReport"
  | "adminOrdersReport";

export interface AdminDashboardQuery {
  timezone: string;
  startDate: string;
  endDate: string;
  orderPartnerType?: AdminDashboardPartnerType;
  partnerType?: AdminDashboardPartnerType;
  partnerId?: number;
  sortBy?: string;
  sortDirection?: "asc" | "desc";
}

export interface AdminDashboardExportQuery {
  section: AdminDashboardExportSection;
  timezone: string;
  startDate: string;
  endDate: string;
}

export const getAdminDashboardReports = (
  params: AdminDashboardQuery,
  token?: string,
) => {
  return customAxios({
    method: "GET",
    url: "/admin/dashboard-reports",
    params,
    ...(token
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : {}),
  });
};

export const exportAdminDashboardReport = (
  params: AdminDashboardExportQuery,
  token?: string,
) => {
  return customAxios({
    method: "GET",
    url: "/admin/dashboard-reports/export",
    params,
    responseType: "blob",
    ...(token
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : {}),
  });
};

export const updateOrderPayoutStatus = (
  orderId: number,
  payoutStatus: "Paid" | "Pending" | "Cancelled",
  token?: string,
) => {
  return customAxios({
    method: "PUT",
    url: `/admin/dashboard-reports/orders/${orderId}/payout-status`,
    data: {
      payoutStatus: payoutStatus.toLowerCase(),
    },
    ...(token
      ? {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      : {}),
  });
};
